import { formatDashboardLastRefreshed } from './formatDashboardLastRefreshed';

export interface DashboardHeaderActionsProps {
  loading: boolean;
  customizing: boolean;
  lastRefreshedAt: Date | null;
  onRefresh: () => void;
  onToggleCustomize: () => void;
}

/** Icon-only refresh and customize actions — plain HTML to avoid DX #185 on first paint. */
export function DashboardHeaderActions({
  loading,
  customizing,
  lastRefreshedAt,
  onRefresh,
  onToggleCustomize
}: DashboardHeaderActionsProps) {
  return (
    <div className="dashboard-actions">
      {lastRefreshedAt ? (
        <span className="dashboard-last-refresh" aria-live="polite">
          Updated {formatDashboardLastRefreshed(lastRefreshedAt)}
        </span>
      ) : null}
      <button
        type="button"
        className={[
          'dashboard-actions__btn',
          loading ? 'dashboard-actions__refresh--loading' : ''
        ]
          .filter(Boolean)
          .join(' ')}
        title={loading ? 'Refreshing dashboard…' : 'Refresh dashboard'}
        aria-label="Refresh dashboard"
        disabled={loading}
        onClick={onRefresh}
      >
        <i className="dx-icon dx-icon-refresh" aria-hidden />
      </button>
      <button
        type="button"
        className={[
          'dashboard-actions__btn',
          customizing ? 'dashboard-actions__customize--active' : ''
        ]
          .filter(Boolean)
          .join(' ')}
        title={
          customizing
            ? 'Done customizing — exit layout mode'
            : 'Customize dashboard — show, hide, and reorder cards'
        }
        aria-label={customizing ? 'Done customizing' : 'Customize dashboard'}
        onClick={onToggleCustomize}
      >
        <i className={`dx-icon dx-icon-${customizing ? 'close' : 'preferences'}`} aria-hidden />
      </button>
    </div>
  );
}
